var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import '@/ajs/helpers';
import { getHoursMinutesFromTime } from '@/shared/utils/dateHelper';
import classNames from 'classnames';
import DashboardTile from './DashboardTile';
import messages from '../../dashboardMessages';
var DashboardTimeTile = function (_a) {
    var title = _a.title, _b = _a.value, value = _b === void 0 ? 0 : _b, onClick = _a.onClick, _c = _a.overtime, overtime = _c === void 0 ? 0 : _c, _d = _a.missing, missing = _d === void 0 ? 0 : _d, _e = _a.className, className = _e === void 0 ? null : _e, onFillGaps = _a.onFillGaps;
    var formatMessage = useIntl().formatMessage;
    var formattedValue = useMemo(function () { return getHoursMinutesFromTime(value || 0); }, [value]);
    var formattedOvertime = useMemo(function () { return getHoursMinutesFromTime(overtime || 0); }, [overtime]);
    var formattedMissingHours = useMemo(function () { return getHoursMinutesFromTime(missing || 0); }, [missing]);
    return (_jsx(DashboardTile, __assign({ title: title, onClick: onClick, value: formattedValue, className: className, onlyTitleClickable: true }, { children: _jsxs(_Fragment, { children: [_jsxs(_Fragment, { children: [_jsx("div", { className: "separator" }), _jsxs("div", __assign({ className: "overtime" }, { children: [_jsx("label", { children: formatMessage(messages.Overtime) }), _jsx("span", { children: formattedOvertime })] }))] }), _jsxs(_Fragment, { children: [_jsx("div", { className: "separator" }), _jsxs("div", __assign({ className: "missing" }, { children: [_jsx("label", { children: formatMessage(messages.MissingHours) }), _jsx("span", __assign({ className: classNames({ red: missing > 0 }) }, { children: formattedMissingHours }))] }))] })] }) })));
};
export default DashboardTimeTile;
